import { useCallback } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'

import { Actions } from 'lmcv/redux/ui/modal'

export const useModal = () => ({
  modal: useSelector(state => state.ui.modal, shallowEqual)
})

export const useOpenModal = props => {
  const dispatch = useDispatch()

  return useCallback(
    (params = {}) => {
      dispatch(Actions.openModal({ ...props, ...params }))
    },
    [dispatch, props]
  )
}

export const useCloseModal = () => {
  const dispatch = useDispatch()
  const handleOnClose = useCallback(() => {
    dispatch(Actions.closeModal())
  }, [dispatch])

  return {
    handleOnClose
  }
}

export const useClearPropsModal = () => {
  const dispatch = useDispatch()
  const handleOnClear = useCallback(() => {
    dispatch(Actions.clearModalProps())
  }, [dispatch])

  return {
    handleOnClear
  }
}

export const useCouponModal = props => {
  const dispatch = useDispatch()

  return useCallback(
    (params = {}) => {
      dispatch(
        Actions.openModal({
          type: 'ModalCoupon',
          dynamic: true,
          hiddenClose: true,
          ...props,
          ...params
        })
      )
    },
    [dispatch, props]
  )
}

export const useCouponShareModal = props => {
  const dispatch = useDispatch()

  return useCallback(
    (params = {}) => {
      dispatch(
        Actions.openModal({
          type: 'ModalShare',
          dynamic: true,
          hiddenClose: true,
          ...props,
          ...params
        })
      )
    },
    [dispatch, props]
  )
}

export const useModuleModal = props => {
  const dispatch = useDispatch()

  return useCallback(
    (params = {}) => {
      dispatch(
        Actions.openModal({
          type: 'ModalModule',
          dynamic: true,
          hiddenClose: true,
          ...props,
          ...params
        })
      )
    },
    [dispatch, props]
  )
}
